import { render } from "./BugReportUserPanel.vue?vue&type=template&id=fccd6fe8&scoped=true"
import script from "./BugReportUserPanel.vue?vue&type=script&lang=js"
export * from "./BugReportUserPanel.vue?vue&type=script&lang=js"

import "./BugReportUserPanel.vue?vue&type=style&index=0&id=fccd6fe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fccd6fe8"]])

export default __exports__